import rcStatistics from '@/views/webpc/MemberStatistics/rcStatisticsApp/rcStatistics'

// 定义路由路径数列表
export default [{
  path: '/rcStatistics',
  icon: 'el-icon-s-data',
  name: '充值消费统计',
  component: rcStatistics
}]



// WEBPACK FOOTER //
// ./src/views/webpc/MemberStatistics/rcStatisticsApp/routers/index.js